import PrimeCreationContainer from "containers/jarivsPrime/PrimeCreation";
import React from "react";

const PrimeCreation = (props) => {
  return (
    <>
      <PrimeCreationContainer />
    </>
  );
};

export default PrimeCreation;
